import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import "whatwg-fetch";
import "./EditMatch.css";
import * as FirestoreService from "../../utils/firebase";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuth } from "../../contexts/AdminContext";
import ScoreButton from "../ScoreButton";
const COURTS_NUMBER = [1, 2, 3, 4, 5, 6, 7, 8, 9]
export default function EditMatch(props) {
  let { code } = useParams();
  const [match, setMatch] = useState({});
  const [validCode, setValidCode] = useState(true);

  let { isAdmin } = useAuth();

  useEffect(() => {
    FirestoreService.matchesCollection
      .where("code", "==", code)
      .get()
      .then((e) => {
        if (e.empty) setValidCode(false);
        else {
          e.forEach((doc) => {
            setMatch({
              id: doc.id,
              ...doc.data(),
            });
          });
        }
      })
      .catch((err) => alert(err));
  }, []);

  const decrement = (val) => {
    if (val > 0) return val - 1;
    return val;
  };
  const increment = (val, is3Set) => {
    is3Set = true;
    if (is3Set) {
      // if (val < 50) return val + 1;
      return val + 1;
    } else {
      if (val < 7) return val + 1;
    }
    return val;
  };

  let adminSelects, adminPlayerNames, adminTimeChange;

  const getHoursAndMinutesFromMathTime = (match) => {
    let hours = Math.trunc(match.time / 60);
    let minutes = match.time % 60;
    if (hours < 10) hours = `0${hours}`;
    if (minutes < 10) minutes = `0${minutes}`;
    return hours + ":" + minutes;
  };

  if (isAdmin) {
    // ADMIN TIME INPUT

    adminTimeChange = (
      <input
        value={getHoursAndMinutesFromMathTime(match)}
        onChange={changeScore}
        className="match-form-input"
        type="time"
        name=""
        id="timeChange"
        required
      />
    );

    // ADMIN SELECTS
    let matchesStatuses = ["Nierozpoczęty", "W trakcie", "Zakończony"];

    adminSelects = (
      <div>
        <select
          onChange={changeScore}
          className="match-form-input"
          value={match.court}
          name="court"
          id="courtSelect"
        >
          {COURTS_NUMBER.map((court) => (
            <option value={court}>Kort {court}</option>
          ))}
        </select>
        <select
          onChange={changeScore}
          className="match-form-input"
          value={match.status}
          name="status"
          id="statusSelect"
        >
          {matchesStatuses.map((status) => (
            <option value={status}>{status}</option>
          ))}
        </select>
      </div>
    );
  }

  if (isAdmin)
    adminPlayerNames = (
      <div className="match-form-header">
        <input
          onChange={changePlayerName}
          onBlur={changeScore}
          id="player1"
          className="match-form-label match-form-title-input"
          value={match.player1}
          type="text"
          readOnly={false}
        />{" "}
        -{" "}
        <input
          onChange={changePlayerName}
          onBlur={changeScore}
          id="player2"
          className="match-form-label match-form-title-input"
          type="text"
          value={match.player2}
          readOnly={false}
        />
      </div>
    );
  else
    adminPlayerNames = (
      <div className="match-form-header">
        <span id="player1" className="match-form-label">
          {match.player1}
        </span>{" "}
        -{" "}
        <span id="player2" className="match-form-label">
          {match.player2}
        </span>
      </div>
    );

  function isTieBreak(match) {
    if (match.set1player1 === 6 && match.set1player2 === 6) return true;
    if (match.set2player1 === 6 && match.set2player2 === 6) return true;
    if (match.set3player1 === 6 && match.set3player2 === 6) return true;
  }

  function changeScore(e) {
    try {
      let updatedMatch = { ...match };
      console.log(updatedMatch);
      const id = e.target.id;
      const actionType = e.target.dataset.action;
      const setAndPlayer = e.target.dataset.setandplayer;
      const tiebreak = isTieBreak(updatedMatch);
      if (id.includes("scoreplayer")) {
        if (actionType === "decrement") {
          if (tiebreak) updatedMatch[id] -= 1;
          else if (updatedMatch[id] == 15 || updatedMatch[id] == 30) {
            updatedMatch[id] -= 15;
          } else if (updatedMatch[id] == 40) updatedMatch[id] -= 10;
          else {
            updatedMatch[id] = 40;
          }
        } else if (actionType === "increment") {
          if (tiebreak) updatedMatch[id] += 1;
          else if (updatedMatch[id] == 0 || updatedMatch[id] == 15) {
            updatedMatch[id] += 15;
          } else if (updatedMatch[id] == 30) updatedMatch[id] += 10;
          else {
            updatedMatch[id] = "AD";
          }
        }
        FirestoreService.updateMatch(match.id, {
          [setAndPlayer]: updatedMatch[setAndPlayer],
        }).then((data) => setMatch({ ...match, ...data }));
      }

      //if (actionType) {
      else if (actionType) {
        if (actionType === "decrement") {
          updatedMatch[setAndPlayer] = decrement(updatedMatch[setAndPlayer]);
        } else if (actionType === "increment") {
          updatedMatch[setAndPlayer] = increment(
            updatedMatch[setAndPlayer],
            setAndPlayer.includes("3")
          );
        }
        FirestoreService.updateMatch(match.id, {
          [setAndPlayer]: updatedMatch[setAndPlayer],
        }).then((data) => setMatch({ ...match, ...data }));
      } else if (id === "courtSelect") {
        updatedMatch.court = parseInt(e.target.value);
        FirestoreService.updateMatch(match.id, {
          court: updatedMatch.court,
        }).then((data) => setMatch({ ...match, ...data }));
      } else if (id === "statusSelect") {
        updatedMatch.status = parseInt(e.target.value);
        FirestoreService.updateMatch(match.id, {
          status: updatedMatch.status,
        }).then((data) => setMatch({ ...match, ...data }));
      }

      if (id.startsWith("player")) {
        updatedMatch[id] = e.target.value;
        FirestoreService.updateMatch(match.id, {
          [id]: updatedMatch[id],
        }).then((data) => setMatch({ ...match, ...data }));
      }

      if (id === "timeChange") {
        // CONVERT TIME INPUT TO MINUTES
        let hoursAndMinutes = e.target.value.split(":");
        hoursAndMinutes[0] = parseInt(hoursAndMinutes[0]);
        hoursAndMinutes[1] = parseInt(hoursAndMinutes[1]);
        let minutes = hoursAndMinutes[0] * 60 + hoursAndMinutes[1];
        updatedMatch.time = minutes;

        FirestoreService.updateMatch(match.id, {
          time: updatedMatch.time,
        }).then((data) => setMatch({ ...match, ...data }));
      }
    } catch (err) {
      alert(err);
    }
  }

  function changePlayerName(e) {
    let updatedMatch = { ...match };
    const playerId = e.target.id;
    updatedMatch[playerId] = e.target.value;
    setMatch({ ...updatedMatch });
  }

  const resetSmallPoints = () => {
    FirestoreService.updateMatch(match.id, {
      scoreplayer1: 0,
      scoreplayer2: 0,
    }).then((data) => setMatch({ ...match, ...data }));
  };

  const sets = [1, 2, 3];
  return validCode ? (
    <div className="match-form" id="matchForm">
      <ToastContainer autoClose={500} pauseOnHover={false} />
      {adminPlayerNames}
      {sets.map((set) => (
        <div className="form-group">
          <span className="match-form-title">Set {set} </span>{" "}
          <ScoreButton
            onClick={changeScore}
            actionType={"decrement"}
            setAndPlayer={`set${set}player1`}
          />
          <input
            //type="number"
            name={`set${set}player1`}
            value={match[`set${set}player1`]}
            className="match-form-score-input"
          />
          <ScoreButton
            onClick={changeScore}
            actionType={"increment"}
            setAndPlayer={`set${set}player1`}
          />
          <span className="match-form-label">:</span>
          <ScoreButton
            onClick={changeScore}
            actionType={"decrement"}
            setAndPlayer={`set${set}player2`}
          />
          <input
            //type="number"
            name={`set${set}player2`}
            value={match[`set${set}player2`]}
            className="match-form-score-input"
          />
          <ScoreButton
            onClick={changeScore}
            actionType={"increment"}
            setAndPlayer={`set${set}player2`}
          />
        </div>
      ))}

      <div className="form-group">
        <span className="match-form-title">Wynik </span>{" "}
        <ScoreButton
          scoreId={"scoreplayer1"}
          onClick={changeScore}
          actionType={"decrement"}
          setAndPlayer={`scoreplayer1`}
        />
        <input
          //type="number"
          name={`scoreplayer1`}
          value={match[`scoreplayer1`]}
          className="match-form-score-input"
        />
        <ScoreButton
          scoreId={"scoreplayer1"}
          onClick={changeScore}
          actionType={"increment"}
          setAndPlayer={`scoreplayer1`}
        />
        <span className="match-form-label">:</span>
        <ScoreButton
          scoreId={"scoreplayer2"}
          onClick={changeScore}
          actionType={"decrement"}
          setAndPlayer={`scoreplayer2`}
        />
        <input
          //type="number"
          name={`scoreplayer2`}
          value={match[`scoreplayer2`]}
          className="match-form-score-input"
        />
        <ScoreButton
          scoreId={"scoreplayer2"}
          onClick={changeScore}
          actionType={"increment"}
          setAndPlayer={`scoreplayer2`}
        />
        <button onClick={resetSmallPoints} className="increment-btn reloadBtn">
          &#x21bb;
        </button>
      </div>

      <div>
        <select
          onChange={changeScore}
          className="match-form-input"
          value={match.court}
          name="court"
          id="courtSelect"
        >
          {COURTS_NUMBER.map(num => <option value={num}>Kort {num}</option>)}

        </select>
        <select
          onChange={changeScore}
          className="match-form-input"
          value={match.status}
          name="status"
          id="statusSelect"
        >
          <option value="1">Nierozpoczęty</option>
          <option value="2">W trakcie</option>
          <option value="0">Zakończony</option>
        </select>
      </div>
      {adminTimeChange}
      <span className="match-form-label" id="code" data-code={match.code}>
        Kod: {code}
      </span>
    </div>
  ) : (
    <div className="client-code-form match-form">
      <span className="match-form-label"> Nieprawdiłowy kod</span>
    </div>
  );

  // VALID CODE
  if (validCode) {
  }

  // INVALID CODE
  return;
}
